/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../clients/axios.ts";
import type { RequestConfig, ResponseErrorConfig } from "../../../clients/axios.ts";
import type { PostApiAlbumCollectionsMutationRequest, PostApiAlbumCollectionsMutationResponse, PostApiAlbumCollections400, PostApiAlbumCollections401, PostApiAlbumCollections403, PostApiAlbumCollections500 } from "../../types/PostApiAlbumCollections.ts";
import { postApiAlbumCollectionsMutationResponseSchema, postApiAlbumCollectionsMutationRequestSchema } from "../../zod/AlbumCollectionSchemas/postApiAlbumCollectionsSchema.ts";

function getPostApiAlbumCollectionsUrl() {
  const res = { method: 'POST', url: `/api/album-collections` as const }  
  return res
}

/**
 * @summary Создание выпуска
 * {@link /api/album-collections}
 */
export async function postApiAlbumCollections({ data }: { data?: PostApiAlbumCollectionsMutationRequest }, config: Partial<RequestConfig<PostApiAlbumCollectionsMutationRequest>> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const requestData = postApiAlbumCollectionsMutationRequestSchema.parse(data)  
  
  const res = await request<PostApiAlbumCollectionsMutationResponse, ResponseErrorConfig<PostApiAlbumCollections400 | PostApiAlbumCollections401 | PostApiAlbumCollections403 | PostApiAlbumCollections500>, PostApiAlbumCollectionsMutationRequest>({ method : "POST", url : getPostApiAlbumCollectionsUrl().url.toString(), data : requestData, ... requestConfig, headers : { 'Content-Type': 'application/*+json', ...requestConfig.headers } })  
  return postApiAlbumCollectionsMutationResponseSchema.parse(res.data)
}